import Subject from './subject';

const resourceSubjects = {};

export default function resourceSubject(resourceName) {
  if (resourceName in resourceSubjects) {
    return resourceSubjects[resourceName];
  }
  resourceSubjects[resourceName] = new Subject();
  return resourceSubjects[resourceName];
}
